// extracted by mini-css-extract-plugin
export var attachmentContainer = "_me-0";
export var fileList = "_me-2";
export var removeFileButton = "_me-1";